import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';

/**
 * Whether the selected paidol locks transactions to whoever holds their current
 * step. Off keeps today's rules.
 *
 * Strictly True, not merely truthy: an unset or oddly-typed value must read as
 * off, so an account that never opted in can never be locked by a hydration gap.
 */
export const useEditLockingEnabled = (): boolean =>
  useAppSelector(selectUserCompanies).selectedPaidol?.editLockingSettings?.isEnabled === true;
